import { MMPagination } from '@components'
import CoreLoader from '@components/CoreLoader'
import ExpenseTabs from '@components/ExpenseTabs'
import { useLazyGetCounterpartiesQuery } from 'mmfintech-backend-api'
import { tr, useDelayedExecute, useFilter, usePagination } from 'mmfintech-commons'
import { useEffect, useState } from 'react'
import CounterpartyTable from './elements/CounterpartyTable/CounterpartyTable'

import './counterpartyDashboard.scss'

const CounterpartyDashboard = () => {
  const tabs = [
    { title: tr('FRONTEND.COUNTERPARTY.TABS.ACTIVE', 'Active'), name: 'active' },
    { title: tr('FRONTEND.COUNTERPARTY.TABS.ARCHIVED', 'Archived'), name: 'archived' },
    { title: tr('FRONTEND.COUNTERPARTY.TABS.ALL', 'All'), name: 'all' }
  ]

  const [activeTab, setActiveTab] = useState(tabs[0].name)
  const [getCounterparties, { data, isLoading, isFetching }] = useLazyGetCounterpartiesQuery()

  const filter = useFilter(
    {
      state: 'ACTIVE'
    },
    [],
    [],
    () => {
      delayedReload.execute()
    },
    true
  )

  const delayedReload = useDelayedExecute({
    onExecute: () => pagination.reload({ page: 0 })
  })

  const pagination = usePagination({
    rowsPerPage: 7,
    reload: async (params: any, onSuccess: (response: any) => void) => {
      try {
        const response = await getCounterparties({
          ...params,
          ...filter.prepare(),
          includeExpenseMetrics: false,
          owner: false
        }).unwrap()

        onSuccess(response)
      } catch {}
    }
  })

  const handleTabChange = (tab: string) => {
    if (tab !== activeTab) {
      setActiveTab(tab)
      filter.set('state', tab === 'active' ? 'ACTIVE' : tab === 'archived' ? 'ARCHIVED' : null)
    }
  }

  useEffect(() => {
    pagination.reload()
  }, [activeTab])

  return (
    <div className='counterparty-wrapper'>
      <div className='table-wrapper'>
        <div className='counterparty-header'>
          <ExpenseTabs config={tabs} currentTab={activeTab} setTab={handleTabChange} />
        </div>

        {isLoading || isFetching ? (
          <CoreLoader />
        ) : (
          <>
            <CounterpartyTable data={data?.content || []} />
            <MMPagination {...pagination.register()} />
          </>
        )}
      </div>
    </div>
  )
}

export default CounterpartyDashboard
